import {
  imgproxySettings,
  mobileImgproxySettings,
  resolveLifestyleSelectedOptions as resolveOptions,
  resolveLifestyleOptionsFromSKU as resolveOptionsFromSKU,
} from './shared.mjs'

export const frame = {
  id: 'frame',
  name: 'Frame',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    Fclear: {
      pathTemplate: 'gs://sg360/250430/classics4/c4f_Fclear_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250430/classics4/c4f_Fclear_{nnn}.png',
    },
    clear: {
      pathTemplate: 'gs://sg360/250430/classics4/c4f_Fclear_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250430/classics4/c4f_Fclear_{nnn}.png',
    },
    black: {
      pathTemplate: 'gs://sg360/250430/classics4/c4f_Mblack_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250430/classics4/c4f_Mblack_{nnn}.png',
    },
    grey: {
      pathTemplate: 'gs://sg360/250430/classics4/c4f_Mgrey_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250430/classics4/c4f_Mgrey_{nnn}.png',
    },
    navy: {
      pathTemplate: 'gs://sg360/250430/classics4/c4f_Mnavy_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250430/classics4/c4f_Mnavy_{nnn}.png',
    },
    blacktortoise: {
      pathTemplate: 'gs://sg360/250430/classics4/c4f_Mblacktortoise_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250430/classics4/c4f_Mblacktortoise_{nnn}.png',
    },
    carbon: {
      pathTemplate: 'gs://sg360/250430/classics4/c4f_Mcarbon_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250430/classics4/c4f_Mcarbon_{nnn}.png',
    },
    stone: {
      pathTemplate: 'gs://sg360/250430/classics4/c4f_Mstone_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250430/classics4/c4f_Mstone_{nnn}.png',
    },
    tortoise: {
      pathTemplate: 'gs://sg360/250430/classics4/c4f_Mtortoise_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250430/classics4/c4f_Mtortoise_{nnn}.png',
    },
    white: {
      pathTemplate: 'gs://sg360/250430/classics4/c4f_Mwhite_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250430/classics4/c4f_Mwhite_{nnn}.png',
    },
  },
}

export const icons = {
  id: 'icons',
  name: 'Icons',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    Bblack: {
      pathTemplate: 'gs://sg360/250430/classics4/c4i_Bblack_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250430/classics4/c4i_Bblack_{nnn}.png',
    },
    Bblue: {
      pathTemplate: 'gs://sg360/250430/classics4/c4i_Bblue_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250430/classics4/c4i_Bblue_{nnn}.png',
    },
    Bgold: {
      pathTemplate: 'gs://sg360/250430/classics4/c4i_Bgold_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250430/classics4/c4i_Bgold_{nnn}.png',
    },
    Bgreen: {
      pathTemplate: 'gs://sg360/250430/classics4/c4i_Bgreen_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250430/classics4/c4i_Bgreen_{nnn}.png',
    },
    Bred: {
      pathTemplate: 'gs://sg360/250430/classics4/c4i_Bred_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250430/classics4/c4i_Bred_{nnn}.png',
    },
    Bsilver: {
      pathTemplate: 'gs://sg360/250430/classics4/c4i_Bsilver_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250430/classics4/c4i_Bsilver_{nnn}.png',
    },
    Bwhite: {
      pathTemplate: 'gs://sg360/250430/classics4/c4i_Bwhite_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250430/classics4/c4i_Bwhite_{nnn}.png',
    },
    Bgunmetal: {
      pathTemplate: 'gs://sg360/250430/classics4/c4i_Bgunmetal_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250430/classics4/c4i_Bgunmetal_{nnn}.png',
    },
    Bpink: {
      pathTemplate: 'gs://sg360/260811/c4i_Bpink_{nnn}.png',
      staticPathTemplate: 'gs://sg360/260811/c4i_Bpink_{nnn}.png',
    },
    Broyal: {
      pathTemplate: 'gs://sg360/260811/c4i_Broyal_{nnn}.png',
      staticPathTemplate: 'gs://sg360/260811/c4i_Broyal_{nnn}.png',
    },
  },
}

export const lenses = {
  id: 'lens',
  name: 'Lenses',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    blue: {
      pathTemplate: 'gs://sg360/250430/classics4/c4le_blue_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250430/classics4/c4le_blue_{nnn}.png',
    },
    brown: {
      pathTemplate: 'gs://sg360/250430/classics4/c4le_brown_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250430/classics4/c4le_brown_{nnn}.png',
    },
    fire: {
      pathTemplate: 'gs://sg360/250430/classics4/c4le_fire_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250430/classics4/c4le_fire_{nnn}.png',
    },
    gold: {
      pathTemplate: 'gs://sg360/250430/classics4/c4le_gold_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250430/classics4/c4le_gold_{nnn}.png',
    },
    green: {
      pathTemplate: 'gs://sg360/250430/classics4/c4le_green_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250430/classics4/c4le_green_{nnn}.png',
    },
    pink: {
      pathTemplate: 'gs://sg360/250430/classics4/c4le_pink_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250430/classics4/c4le_pink_{nnn}.png',
    },
    silverblue: {
      pathTemplate: 'gs://sg360/250430/classics4/c4le_silverblue_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250430/classics4/c4le_silverblue_{nnn}.png',
    },
    smoke: {
      pathTemplate: 'gs://sg360/250430/classics4/c4le_smoke_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250430/classics4/c4le_smoke_{nnn}.png',
    },
    clear: {
      pathTemplate: 'gs://sg360/270624/Classics/c3le/c3le_clear_{nnn}.png',
      staticPathTemplate: 'gs://sg360/270624/Classics/c3le/c3le_clear_{nnn}.png',
    },
  },
}

export const reflection = {
  id: 'reflections',
  isReflection: true,
  name: 'Reflections',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    none: {
      disabled: true,
    },
  },
}

export const engraving = {
  id: 'engraving',
  name: 'Engraving',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    eN: {
      pathTemplate: 'gs://sg360/220520/Classics/c3lg/c3lg_N_{nnn}.png',
    },
    eP: {
      pathTemplate: 'gs://sg360/220520/Classics/c3lg/c3lg_P_{nnn}.png',
    },
    e8: {
      pathTemplate: 'gs://sg360/220520/Classics/c3lg/c3lg_8_{nnn}.png',
    },
    e8P: {
      pathTemplate: 'gs://sg360/220520/Classics/c3lg/c3lg_8P_{nnn}.png',
    },
    none: {
      disabled: true,
    },
  },
}

export const background = {
  id: 'background',
  name: 'Background',
  imgproxySettings: ['insecure', 'resize:fill:1400', 'plain'],
  mobileImgproxySettings: ['insecure', 'resize:fill:800', 'plain'],
  isBackground: true,
  options: {
    default: {
      pathTemplate: 'gs://sg360/250430/classics4/c4_shadow_{nnn}.png',
    },
  },
}

export default {
  layers: [background, frame, icons, lenses, engraving, reflection],
  resolveOptions,
  resolveOptionsFromSKU,
}
